const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const ControlPlatform = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CONTROL_PLATFORM_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'CONTROL_PLATFORM_ERROR':
            return { loading: false, error: true, data: [] };
        case 'CONTROL_PLATFORM_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'CONTROL_PLATFORM_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default ControlPlatform